import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  Home,
  Package,
  TrendingUp,
  ShoppingCart,
  Truck,
  Settings,
  RefreshCw,
  BarChart3,
  LogOut,
  Grid3x3,
} from "lucide-react";
import { useAuth } from "../../auth/AuthContext";

const navItems = [
  { to: "/", icon: Home, label: "Home" },
  { to: "/inventario", icon: Package, label: "Inventario" },
  { to: "/ventas", icon: TrendingUp, label: "Ventas" },
  { to: "/analisis", icon: Grid3x3, label: "Análisis" },
  { to: "/compras", icon: ShoppingCart, label: "Compras" },
  { to: "/proveedores", icon: Truck, label: "Proveedores" },
  { to: "/productos", icon: BarChart3, label: "Productos" },
];

export default function Sidebar({ onSync, syncing }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  const initials = (user?.displayName || user?.username || "?")
    .split(/[\s.@]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s.charAt(0).toUpperCase())
    .join("") || "?";

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <Package size={24} />
          <span>PetShop</span>
        </div>
      </div>

      <nav className="sidebar-nav">
        <div className="sidebar-section">
          <div className="sidebar-section-title">Menu</div>
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
              end={item.to === "/"}
            >
              <item.icon size={18} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </div>

        <div className="sidebar-section">
          <div className="sidebar-section-title">Sistema</div>
          <button
            className="sidebar-link"
            onClick={onSync}
            disabled={syncing}
            style={{ width: "100%", border: "none", background: "none", cursor: syncing ? "wait" : "pointer" }}
          >
            <RefreshCw size={18} className={syncing ? "animate-spin" : ""} />
            <span>{syncing ? "Sincronizando..." : "Sincronizar"}</span>
          </button>
          <NavLink to="/settings" className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}>
            <Settings size={18} />
            <span>Configuración</span>
          </NavLink>
        </div>
      </nav>

      <div className="sidebar-footer">
        {user && (
          <div className="sidebar-user">
            <div className="sidebar-user-avatar" aria-hidden="true">{initials}</div>
            <div className="sidebar-user-meta">
              <div className="sidebar-user-name">{user.displayName}</div>
              <div className="sidebar-user-role">
                {user.role === "admin" ? "Administrador" : "Usuario"}
              </div>
            </div>
            <button
              className="sidebar-user-logout"
              onClick={handleLogout}
              title="Cerrar sesión"
              aria-label="Cerrar sesión"
            >
              <LogOut size={15} />
            </button>
          </div>
        )}
        <div style={{ fontSize: "11px", color: "var(--text-tertiary)", marginTop: 8 }}>
          PetShop Command Center
        </div>
      </div>
    </aside>
  );
}
